<div class="w-100">
  <picture *ngIf="getshow == 'false'">
      <source media="(min-width: 721px)" srcset="../../../assets/img/endding/2025/ending-survey01.jpg">
      <img alt="bg-voucher" class="img-fluid voucher-bg-center" src="../../../assets/img/endding/2025/ending-survey01.jpg">
  </picture>

  <picture *ngIf="getshow == 'true'" (click)="goToPage('https://vip.ptkcg.co.id/')">
      <source media="(min-width: 721px)" srcset="../../../assets/img/endding/2025/ending-survey02.jpg">
      <img alt="bg-voucher" class="img-fluid voucher-bg-center" src="../../../assets/img/endding/2025/ending-survey02.jpg">
  </picture>

  <!-- desktop -->
  <div class="d-none d-lg-block">
      <div class="text-center placement-voucher-desktop">
        <div class="voucher-button">
          <span>
              <b>{{voucher}}</b>
          </span>
        </div>
      </div>
  </div>

  <!-- tablet -->
  <div class="d-none d-md-block d-lg-none">
      <div class="text-center placement-voucher">
          <div class="text-center placement-voucher-tablet">
            <div class="voucher-button">
              <span>
                  <b>{{voucher}}</b>
              </span>
            </div>
          </div>
      </div>
  </div>

  <!-- mobile -->
  <div class="d-block d-md-none">
      <div class="text-center placement-voucher-mobile">
        <div class="voucher-button">
          <span>
              <b>{{voucher}}</b>
          </span>
        </div>
      </div>
  </div>
</div>
